// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageContainerStyles } from "@turnerBlueprint/Overrides/Widgets/Cart/CartPageContainer";
import { css } from "styled-components";

cartPageContainerStyles.cartPageTemplateStyles = {
    container: {
        css: css`
            @media print {
                ${({ currentView }: any) =>
                    currentView === "condensed" &&
                    `
                        display: flex !important;
                        flex-wrap: wrap;
                    `}
            }
        `,
    },
    mainSection: {
        css: css`
            @media print {
                ${({ currentView }: any) => currentView === "condensed" && `width: 100%;`}
            }
        `,
    },
    totalSection: {
        css: css`
            @media print {
                ${({ currentView }: any) =>
                    currentView === "condensed" &&
                    `
                        width: 100%;
                        margin-top: 24px;
                        order: 3;
                        & > div.xng-sticky {
                            position: static;
                            max-width: 100%;
                            display: flex;
                            gap: 10px;
                        }
                    `}
            }
        `,
    },
};
